import { render, staticRenderFns } from "./TableGpPerMonth.vue?vue&type=template&id=882e9af4&"
import script from "./TableGpPerMonth.vue?vue&type=script&lang=js&"
export * from "./TableGpPerMonth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports